import { useState } from 'react';
import NavItem from '../navigation/NavItem';

interface Topic {
  id: string;
  title: string;
}

interface NavSection {
  id: string;
  title: string;
  icon: string;
  topics?: Topic[];
}

interface SidebarNavProps {
  sections: NavSection[];
  currentSectionId: string | null;
  currentTopicId: string | null;
  onSectionClick: (sectionId: string) => void;
  onTopicClick: (sectionId: string, topicId: string) => void;
}

export default function SidebarNav({
  sections,
  currentSectionId,
  currentTopicId,
  onSectionClick,
  onTopicClick,
}: SidebarNavProps) {
  const [expandedItems, setExpandedItems] = useState<string[]>(() => {
    // Auto-expand current section
    return currentSectionId ? [currentSectionId] : [];
  });

  const handleToggleExpand = (id: string) => {
    setExpandedItems((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <nav className="flex-1 overflow-auto p-3">
      {sections.map((item) => (
        <NavItem
          key={item.id}
          item={item}
          isActive={currentSectionId === item.id}
          currentTopicId={currentTopicId}
          onSectionClick={() => onSectionClick(item.id)}
          onTopicClick={(topicId) => onTopicClick(item.id, topicId)}
          expandedItems={expandedItems}
          onToggleExpand={handleToggleExpand}
        />
      ))}
    </nav>
  );
}
